import { createSlice } from "@reduxjs/toolkit";
const initialState = {
 // keep the key only if Colum is present in the table
 // keep true to show the column else false to hide 
  data: {
    // projectName: true,
    // projectStatus: true,
    // phases:true,
    // activity:true,
    tasks:true,
    issues: true,
    startDate: true,
    endDate: true,
    group: true,
    createdDate: true,
    createdUserName: true,
    budgetName: false,
    resourceHeads: false,
    materials: false,
    tags: false,
    createdBy: false,    
    owner: false,
    siteName: false,
    calendar: false,

  },
};

export const PendingProjectsListViewTableColumnsConfigSlice = createSlice({
  name: "PendingProjectsListViewTableColumnsConfig",
  initialState,
  reducers: {
    updatePendingProjectsListViewTableColumnsConfig(state, action) {
      state.data = { ...state.data, ...action.payload };
    },
    resetPendingProjectsListViewTableColumnsConfig(state) {
      state.data = initialState.data;
    },
  },
});

export const {
  updatePendingProjectsListViewTableColumnsConfig,
  resetPendingProjectsListViewTableColumnsConfig,
} = PendingProjectsListViewTableColumnsConfigSlice.actions;

